import { createElement } from 'src/app/core/helpers/dom';
import { hasActiveQuickFilters } from '../../../../filters/utils/count-active-quick-filters';
import { GET_TIMELINE } from '../../timeline.ui.store';

const NO_POINTS_MESSAGE = 'No points to display on the Timeline.';
const NO_MATCHING_RESULTS_MESSAGE = 'No matching filter results.';

export function createEmptyMessageNameElement(): HTMLElement {
  const quickFilters = GET_TIMELINE()?.quickFilterService.getFilters();
  const filtersApplied = quickFilters ? hasActiveQuickFilters(quickFilters) : false;

  return createElement('div', {
    children: [filtersApplied ? NO_MATCHING_RESULTS_MESSAGE : NO_POINTS_MESSAGE],
  });
}
